
import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";

interface NotFoundCardProps {
  message: string;
  description: string;
}

export const NotFoundCard = ({ message, description }: NotFoundCardProps) => {
  return (
    <Card>
      <CardContent className="py-12 text-center">
        <AlertTriangle className="h-12 w-12 mx-auto mb-4 text-amber-500" />
        <h3 className="text-lg font-medium mb-2">{message}</h3>
        <p className="text-muted-foreground">
          {description}
        </p>
      </CardContent>
    </Card>
  );
};
